export class Author {
    firstName: string;
    lastName: string;
    authorUrl: string;
}
